var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43205",
    "data-name": "Group 43205",
    transform: "translate(3382 -17692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3081",
    "data-name": "Ellipse 3081",
    transform: "translate(-3382 17692)",
    fill: "#fff",
    stroke: "#d4d8de",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43205-2",
    "data-name": "Group 43205",
    transform: "translate(-3374 17700)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14899",
    "data-name": "Rectangle 14899",
    width: 16,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "down-arrow",
    d: "M6.517,8.987a1,1,0,0,1,1.291,0L13.25,13.8l5.441-4.813a1,1,0,0,1,1.291,0,.744.744,0,0,1,0,1.142L13.9,15.513a1,1,0,0,1-1.291,0L6.517,10.129a.744.744,0,0,1,0-1.142Z",
    transform: "translate(-5.25 -3.75)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/arrow-down-circle.c7e4ed42ae7c0e6a2f299af9f71f0011.svg";
export { ForwardRef as ReactComponent };